import { useLocation, useNavigationType } from 'react-router-dom'

export const useReplaceUrlHandler = () => {
  const { state } = useLocation()
  const navigationType = useNavigationType()
  const prevPath = state?.prevPath
  const prevUrl = `${location.protocol}//${location.host}${import.meta.env?.BASE_URL.slice(0, -1) || ''}${
    prevPath || ''
  }`
  const canReplaceUrl = (prevPath && navigationType === 'POP') || !prevPath
  const replaceUrl = () => location.replace(prevUrl)

  if (canReplaceUrl) return replaceUrl()

  return { canReplaceUrl, replaceUrl }
}

/** 사용자 에이전트를 통해 디바이스 OS를 판별 */
export function getDeviceOS(): any {
  if (navigator.userAgent.match(/Android/i)) {
    return 'android'
  } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    return 'ios'
  } else {
    return null
  }
}

/** 사용자 에이전트를 통해 현재 브라우저를 판별 */
export function getCurrentBrowser(): any {
  const userAgent = navigator.userAgent.toLowerCase()

  if (userAgent.match(/samsung/i)) {
    return 'samsung'
  } else if (userAgent.match(/whale/i)) {
    return 'whale'
  } else if (userAgent.match(/kakaotalk/i)) {
    return 'kakaotalk'
  } else if (userAgent.match(/chrome|chromium|crios/i)) {
    return 'chrome'
  } else if (userAgent.match(/safari/i)) {
    return 'safari'
  } else if (userAgent.match(/firefox|fxios/i)) {
    return 'firefox'
  } else if (userAgent.match(/opr\//i)) {
    return 'opera'
  } else if (userAgent.match(/edg/i)) {
    return 'edge'
  } else {
    return null
  }
}

/** 센서 문제 해결 정보 텍스트를 담고있는 객체 */
export const sensorFixData: any = {
  android: {
    samsung: {
      camera: [
        'page.error.sensor.android.samsung.camera.1',
        'page.error.sensor.android.samsung.camera.2',
        'page.error.sensor.android.samsung.camera.3',
        'page.error.sensor.android.samsung.camera.4',
      ],
      gps: [
        'page.error.sensor.android.samsung.gps.1',
        'page.error.sensor.android.samsung.gps.2',
        'page.error.sensor.android.samsung.gps.3',
        'page.error.sensor.android.samsung.gps.4',
      ],
      cameraRefreshable: false,
    },
    chrome: {
      camera: [
        'page.error.sensor.android.chrome.camera.1',
        'page.error.sensor.android.chrome.camera.2',
        'page.error.sensor.android.chrome.camera.3',
        'page.error.sensor.android.chrome.camera.4',
      ],
      gps: [
        'page.error.sensor.android.chrome.gps.1',
        'page.error.sensor.android.chrome.gps.2',
        'page.error.sensor.android.chrome.gps.3',
        'page.error.sensor.android.chrome.gps.4',
      ],
      cameraRefreshable: false,
    },
    kakaotalk: {
      camera: [],
      gps: [],
      cameraRefreshable: true,
    },
    whale: {
      camera: [
        'page.error.sensor.android.whale.camera.1',
        'page.error.sensor.android.whale.camera.2',
        'page.error.sensor.android.whale.camera.3',
        'page.error.sensor.android.whale.camera.4',
      ],
      gps: [
        'page.error.sensor.android.whale.gps.1',
        'page.error.sensor.android.whale.gps.2',
        'page.error.sensor.android.whale.gps.3',
        'page.error.sensor.android.whale.gps.4',
      ],
      cameraRefreshable: false,
    },
  },
  ios: {
    safari: {
      camera: [
        'page.error.sensor.ios.safari.camera.1',
        'page.error.sensor.ios.safari.camera.2',
        'page.error.sensor.ios.safari.camera.3',
      ],
      gps: [
        'page.error.sensor.ios.safari.gps.1',
        'page.error.sensor.ios.safari.gps.2',
        'page.error.sensor.ios.safari.gps.3',
        'page.error.sensor.ios.safari.gps.4',
        'page.error.sensor.ios.safari.gps.5',
      ],
      cameraRefreshable: true,
    },
    chrome: {
      camera: [
        'page.error.sensor.ios.chrome.camera.1',
        'page.error.sensor.ios.chrome.camera.2',
        'page.error.sensor.ios.chrome.camera.3',
      ],
      gps: [
        'page.error.sensor.ios.chrome.gps.1',
        'page.error.sensor.ios.chrome.gps.2',
        'page.error.sensor.ios.chrome.gps.3',
        'page.error.sensor.ios.chrome.gps.4',
        'page.error.sensor.ios.chrome.gps.5',
      ],
      cameraRefreshable: true,
    },
    kakaotalk: {
      camera: [
        'page.error.sensor.ios.kakaotalk.camera.1',
        'page.error.sensor.ios.kakaotalk.camera.2',
        'page.error.sensor.ios.kakaotalk.camera.3',
      ],
      gps: [
        'page.error.sensor.ios.kakaotalk.gps.1',
        'page.error.sensor.ios.kakaotalk.gps.2',
        'page.error.sensor.ios.kakaotalk.gps.3',
        'page.error.sensor.ios.kakaotalk.gps.4',
        'page.error.sensor.ios.kakaotalk.gps.5',
      ],
      cameraRefreshable: true,
    },
    whale: {
      camera: [
        'page.error.sensor.ios.whale.camera.1',
        'page.error.sensor.ios.whale.camera.2',
        'page.error.sensor.ios.whale.camera.3',
      ],
      gps: [
        'page.error.sensor.ios.whale.gps.1',
        'page.error.sensor.ios.whale.gps.2',
        'page.error.sensor.ios.whale.gps.3',
        'page.error.sensor.ios.whale.gps.4',
        'page.error.sensor.ios.whale.gps.5',
      ],
      cameraRefreshable: true,
    },
  },
}
